import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import './nav.css'

function Navb() {
    const navigate = useNavigate();

    // Carga el idioma guardado al inicio
    useEffect(() => {
        const savedLanguage = localStorage.getItem('preferredLanguage');
        if (savedLanguage) {
            navigate(`/${savedLanguage}`);
        }
    }, [navigate]);

    // Cambia el idioma y redirige
    const handleLanguageChange = (language) => {
        localStorage.setItem('preferredLanguage', language);
        navigate(`/${language}`);
    };
return (
<Navbar collapseOnSelect expand="lg" className="bgnav" data-bs-theme="dark">
    <Container>
    <Navbar.Brand href="#home" className='logo'>AMY</Navbar.Brand>
    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
    <Navbar.Collapse id="responsive-navbar-nav">
        <Nav className="ms-auto">
        <Nav.Link href="#bio" className='navitem'>BIO</Nav.Link>
        <Nav.Link href="#odscontainer" className='navitem'>OdS</Nav.Link>
        <Nav.Link href="#stlcontainer" className='navitem'>STL</Nav.Link>
        <Nav.Link href="#clasescontainer" className='navitem'>CLASSES</Nav.Link>
        <NavDropdown className='navitem' title="LAN" id="basic-nav-dropdown">
            <NavDropdown.Item onClick={() => handleLanguageChange('es')}>SPANISH</NavDropdown.Item>
            <NavDropdown.Item onClick={() => handleLanguageChange('en')}>
            ENGLISH
            </NavDropdown.Item>
            <NavDropdown.Item onClick={() => handleLanguageChange('de')}>GERMAN</NavDropdown.Item>
        </NavDropdown>
        </Nav>
    </Navbar.Collapse>
    </Container>
</Navbar>
);
}

export default Navb;